<template>
  <div class="body-box">
    <!-- 搜索与添加区域 -->
    <el-row class="plan"></el-row>
    <el-table :height="'calc(100% - 40px)'" :data="areaList" style="padding-top: 10px;" class="button-box" row-key="id" sort-by="sort" :tree-props="{ children: 'children' }">
      <el-table-column label="名称" prop="name" width="180" class="left"></el-table-column>
      <el-table-column label="排序" prop="sort"></el-table-column>
      <el-table-column label="是否热门城市" prop="enumHot">
        <template slot-scope="scope">{{scope.row.enumHot === 'YES' ? '是' : '否'}}</template>
      </el-table-column>
      <el-table-column label="是否显示在首页" prop="enumHomePage">
        <template slot-scope="scope">{{scope.row.enumHomePage === 'YES' ? '是' : '否'}}</template>
      </el-table-column>
      <el-table-column label="操作" width="180px">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="editArea(scope.row)">修改</el-button>
          <el-button icon="el-icon-edit" @click="removeAreaById(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <addArea @refresh-list="getAreaList" ref="addArea"></addArea>
    <editArea @refresh-list="getAreaList" ref="editArea"></editArea>
  </div>
</template>
<script>
import addArea from "@/views/area/addArea";
import editArea from "@/views/area/editArea";
import { deleteArea, getTreeArea } from '@/api/area/area'
import { deleteTips } from '@/utils/tips'
import { getPostOrDeleteData } from '@/utils/code'

export default {
  components: { addArea, editArea},
  data() {
    return {
      // 查询参数
      queryInfo: {
        keyword: "",
      },
      areaList: [],
      oneLevelArea:[] //一级城市列表
    };
  },
  mounted() {
    this.getAreaList()
  },
  methods: {
    //查询列表
    getAreaList() {
      getTreeArea().then((res) => {
        this.areaList = res.code === '0' ? res.data : []
        if( this.areaList.length>0  ){
          this.oneLevelArea = []
          this.areaList.forEach(al=>{
            let obj = {
              id:al.id,
              name:al.name
            }
            this.oneLevelArea.push(obj)
          })
        }
      })
    },

    //根据ID删除数据
    async removeAreaById(id) {
      let b = await deleteTips('确定要删除吗? 此操作不能撤销!');
      if (b) {
        deleteArea(id).then((response) => {
          let data = getPostOrDeleteData(response);
          if (data !== null) {
            this.getAreaList()
          }
        })
      }
    },

    //新增
    addArea() {
      this.$refs.addArea.addDialog(this.oneLevelArea)
    },

    //修改
    editArea(row) {
      this.$refs.editArea.editDialog(row)
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  padding-right: 30px;
}

/deep/.el-table--enable-row-transition .el-table__body td:nth-child(1) .cell {
  text-align: left;
  margin-left: 40px;
}
</style>
